module.exports = __webpack_public_path__ + "static/media/mailmessage.1d2877be.svg";